import type { CaringNoteErrorKind } from "services/caringnoteApi";

/**
 * 열람 오류/빈 상태의 화면 문안 (계획 §3-3 · 순수함수 → 단위 테스트).
 *
 * ⚠️ 어떤 상태에도 **로그인 링크·리다이렉트가 없다.** `action`은 재시도만 가능하며
 *    재시도는 `server`·`network`(일시적 오류)에서만 허용한다.
 */
export type CaringNoteStatusKind = CaringNoteErrorKind | "empty";

export interface CaringNoteStatusCopy {
  title: string;
  message: string;
  /** 재시도 버튼 노출 여부 — 일시적 오류에서만 true. */
  canRetry: boolean;
}

const COPY: Record<CaringNoteStatusKind, CaringNoteStatusCopy> = {
  empty: {
    title: "리포트가 아직 준비되지 않았습니다",
    message: "분석이 완료되면 다시 열어주세요.",
    canRetry: true,
  },
  notFound: {
    title: "링크가 유효하지 않습니다",
    // D2(2026-10-15): rel 07059b9 문구로 복원. 이 화면(embed·report)은 케어링노트 전용 경로라
    // 응답·토큰에 파트너 판별 필드가 없다(새 API 필드 금지) → 늘품 문구로 통일(AC-14 해당 없음).
    message: "케어링노트에서 다시 열어주세요.",
    canRetry: false,
  },
  scopeMismatch: {
    title: "이 링크는 이 화면에서 열 수 없습니다",
    // D2(2026-10-15): rel 07059b9 문구로 복원(위 notFound와 같은 근거).
    message: "케어링노트에서 올바른 링크로 다시 열어주세요.",
    canRetry: false,
  },
  server: {
    title: "일시적인 오류입니다",
    message: "잠시 후 다시 시도해 주세요.",
    canRetry: true,
  },
  network: {
    title: "일시적인 오류입니다",
    message: "네트워크 상태를 확인하고 다시 시도해 주세요.",
    canRetry: true,
  },
};

export function describeCaringNoteStatus(kind: CaringNoteStatusKind): CaringNoteStatusCopy {
  return COPY[kind];
}
